import httpStore from "@/api/httpStore.js";

export function getSettings(settingId) {
  return httpStore
    .get("settings?id=" + settingId)
    .then(res => {
      return res.data;
    })
    .catch(() => {
      return null;
    });
}
export function getSettingsSection(settingId = "") {
  return httpStore
    .get("settings/section?id=" + settingId)
    .then(res => {
      return res.data;
    })
    .catch(() => {
      return null;
    });
}

export function updateSetting(key, value, status) {
  return httpStore
    .put("settings", { key: key, value: value, status: status })
    .then(res => {
      return res.data;
    })
    .catch(() => {
      return null;
    });
}

export function getShippingServices() {
  return httpStore.get("shipping/services").then(res => {
    return res.data;
  });
}

// ---------- Local Delivery ----------

export function getLocalDeliveryZipcodes(depositoId) {
  return httpStore
    .get(`local_delivery/zipcodes/${depositoId}`)
    .then(res => res.data);
}

export function addLocalDeliveryZipcodes(depositoId, zipcodes) {
  return httpStore
    .post("local_delivery/zipcodes", {
      deposito_id: depositoId,
      zipcodes
    })
    .then(res => res.data);
}

export function deleteLocalDeliveryZipcode(id) {
  return httpStore
    .delete(`local_delivery/zipcodes/${id}`)
    .then(res => res.data);
}

export function getLocalDeliveryRates() {
  return httpStore.get("local_delivery/rates").then(res => res.data);
}

export function updateLocalDeliveryRates(payload) {
  return httpStore.put("local_delivery/rates", payload).then(res => res.data);
}
